import {
  pipe,
  allPass,
  propSatisfies,
  tap,
  both,
  isNil,
  isEmpty,
  complement,
  compose,
  map
} from 'ramda';

const logValidationFailure = key => result =>
  result ||
  // allowing this console statement to help during development
  // eslint-disable-next-line no-console
  console.error('Unexpected value for required parameter', key);

/**
 * Checks that a parameter with the given key is present on a supplied object and is
 * not null or empty. The result of the validation is returned. If the validation
 * fails, the failure is logged to help during development.
 * @type {(key: string) => (obj: Object) => Boolean}
 */
const isPropValid = key =>
  pipe(
    propSatisfies(both(complement(isNil), complement(isEmpty)), key),
    tap(logValidationFailure(key))
  );

/**
 * Checks that all the provided keys are present and valid on the supplied
 * object, returning the result of this check.
 * @type {(keys: string[]) => (obj: Object) => Boolean}
 */
export const validateProps = compose(allPass, map(isPropValid));
